import { Link } from "react-router-dom";
import { ArrowDownLeft, ArrowUpRight, CreditCard, ArrowsLeftRight, ArrowCounterClockwise, Bank } from "@phosphor-icons/react";
import { inr, fmtDate, TX_META } from "../lib/format";

const ICONS = {
  income: ArrowDownLeft,
  expense: ArrowUpRight,
  card_purchase: CreditCard,
  card_repayment: Bank,
  transfer: ArrowsLeftRight,
  refund: ArrowCounterClockwise,
};

export const TxRow = ({ tx, categories = {} }) => {
  const meta = TX_META[tx.transaction_type] || TX_META.expense;
  const Icon = ICONS[tx.transaction_type] || ArrowUpRight;
  const catNames = (tx.lines || [])
    .map((l) => categories[l.category_id])
    .filter(Boolean)
    .slice(0, 2)
    .join(", ");
  return (
    <Link
      to={`/transactions/${tx.id}`}
      data-testid={`tx-row-${tx.id}`}
      className="flex items-center justify-between gap-3 py-3 border-b border-border last:border-0 active:bg-secondary/50 -mx-1 px-1 rounded-lg"
    >
      <div className={`h-10 w-10 rounded-full flex items-center justify-center shrink-0 ${meta.bg}`}>
        <Icon size={18} className={meta.color} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">
          {tx.merchant || tx.description || meta.label}
        </p>
        <p className="text-xs text-muted-foreground truncate">
          {fmtDate(tx.transaction_date)}
          {catNames ? ` · ${catNames}` : ""}
          {tx.status === "draft" ? " · Draft" : ""}
          {tx.status === "voided" ? " · Voided" : ""}
        </p>
      </div>
      <span className={`text-sm font-semibold tnum ${tx.status === "voided" ? "line-through text-muted-foreground" : meta.color}`}>
        {meta.sign}
        {inr(tx.total_amount)}
      </span>
    </Link>
  );
};
